var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterColorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_13",
    "data-name": 13,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 568 546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m335.85,232.69L552.89,3.26h-50.04l-185.6,202.57L165.01,3.26H1l221.17,299.71L1,542.74h46.83l197.08-210.83,155.31,210.83h166.79l-231.15-310.05ZM74.34,42.53h75.48l347.61,463.01h-78.9L74.34,42.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterColorIcon);
export default __webpack_public_path__ + "static/media/TwitterColorIcon.917ca425dc064f66ca04d92264ad413e.svg";
export { ForwardRef as ReactComponent };